import * as React from 'react';
import type { UseLiveMeetingSessionReturn } from '../types/live-meeting';

/**
 * LiveMeetingSessionContext - shares the active live meeting session state
 * established by LiveMeetingNotificationProvider across the component tree.
 *
 * Consumers (e.g. AppNav) read from this context to access session status
 * without opening a second WebSocket connection.
 */
export const LiveMeetingSessionContext = React.createContext<UseLiveMeetingSessionReturn | null>(
  null
);

/**
 * useLiveMeetingSessionContext - consume the shared live meeting session.
 * Returns null when called outside of LiveMeetingNotificationProvider.
 */
export function useLiveMeetingSessionContext(): UseLiveMeetingSessionReturn | null {
  return React.useContext(LiveMeetingSessionContext);
}
